import { useGetPageMode } from '@confluence/page-utils/entry-points/useGetPageMode';
import { PageMode } from '@confluence/page-utils/entry-points/enums';

const EDITOR = 'EDITOR';
const RENDERER = 'RENDERER';
const LIVE = 'LIVE';

const MODE_TO_LOCATION_MAP = {
	[PageMode.EDIT]: EDITOR,
	[PageMode.VIEW]: RENDERER,
	[PageMode.LIVE]: LIVE,
};

export const useLocation = () => {
	const pageMode = useGetPageMode();

	return MODE_TO_LOCATION_MAP[pageMode];
};
